import { useEffect, useState } from "react";
import api from "utils/api";

function useHasRightPermission(route) {
  const [hasPermission, setHasPermission] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    verifyRoutePermission();
  }, []);

  const verifyRoutePermission = async () => {
    try {
      let result = await api.getRouteAuth(route);
      if (result.status == 200) {
        setHasPermission(true);
      } else {
        setHasPermission(false);
      }
    } catch (error) {
      setHasPermission(false);
    } finally {
      setLoading(false);
    }
  };

  return { hasPermission, loading };
}

export default useHasRightPermission;
